import React from 'react';
import * as Styles from './VpsOpenClawHighlight.styles';
import { GradientButton } from '@/pages/Studio/components';
import { useResize } from '@/hooks/useResize';
import {
  DivContents,
  DivImg,
  Title,
  Description,
  WrapperTitle,
  ButtonWrapper,
} from '../HGStudioHighlight/HGStudioHighlight.styles';

const VpsOpenClawHighlight = ({
  element,
  buttonIsLoading = false,
}) => {
  const windowRect = useResize();
  const { width: windowWidth } = windowRect;
  const mobile = windowWidth < 600;

  return (
    <DivContents id={element.id} key={element.id} data-testid={`highlight-${element.id}`}>
      <DivImg>
        <img
          src={element.image}
          alt="produto em destaque"
        />
      </DivImg>

      <Styles.DivText>
        <WrapperTitle>
          <Title data-testid={`title-${element.id}`}>{element.title}</Title>
        </WrapperTitle>

        <Styles.Subtitle data-testid={`subtitle-${element.id}`}>
          {element.subtitle}
        </Styles.Subtitle>

        <Styles.WrapperDescription>
          <Description data-testid={`description-${element.id}`}>
            {element.description}
          </Description>
        </Styles.WrapperDescription>

        <ButtonWrapper>
          <GradientButton
            testId="cta"
            label={element.cta.label}
            variant="quaternary"
            size="lg"
            version="v2"
            width={mobile ? 'full' : 'fit-content'}
            onClick={element.cta.onClick}
            loading={buttonIsLoading}
            disabled={buttonIsLoading}
          />
        </ButtonWrapper>
      </Styles.DivText>
    </DivContents>
  );
};

export default VpsOpenClawHighlight;
